jQuery(document).ready(function($) {

	//Load jQuery datepicker on contact forms
	var dateToday = new Date();
	$(function() {
		$('.contact-form__input--date').datepicker({
	        minDate: dateToday,
			dateFormat: 'dd/mm/yy'
	    });
	});


});
